import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import store from './store'
import router from './router'
import {getCookieToken} from '@/utils/auth' // 不重定向白名单

const whiteList = ['login']

let initInfo = false

router.beforeEach(async (to, from, next) => {
	NProgress.start() // 开启Progress

	let token = getCookieToken()

	if (token) {
		let userStatus = store.state.user.userStatus
		// 如果未注册，直接跳到register
		if (userStatus === 'unregister') {
			if (to.name === 'register') {
				next()
			} else {
				next({name: 'register'})
			}
		} else {
			if (to.name === 'login' || to.name === 'register') {
				next({name: 'index'})
			} else {
				let userInfo = store.getters['user/getUserInfo']
				// 防止切换路由，频繁请求(正常情况下，到达这里用户信息已经在登录页面获取了)
				if (!userInfo && !initInfo) {
					initInfo = !initInfo
					await store.dispatch('user/fetchUserInfo')
				}
				// 获取到字典
				if (store.getters.dicList.length === 0) {
					await store.dispatch('getDicListAcions')
				}
				next()
			}
		}
	} else {
		if (whiteList.indexOf(to.name) !== -1) { // 在免登录白名单，直接进入
			next()
		} else {
			next({name: 'login'}) // 重定向到登录页
		}
		store.commit('user/logoutMutaion')
	}
})

router.afterEach(() => {
	NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js